import React from 'react';
import { Facebook, Instagram, Linkedin, MapPin, Phone } from 'lucide-react';

const Footer = ({ data = {} }) => {
    return (
        <footer className="bg-slate-900 border-t-8 border-[#cc0000] pt-16 pb-8 text-white">
            <div className="px-5">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16 mb-10">
                    <div className="space-y-4">
                        <div className="flex flex-col">
                            <img 
                                src="/logoback.png" 
                                alt="Arya Sabhyata Logo" 
                                className="h-20 w-auto object-contain self-start" 
                                onError={(e) => { e.target.style.display = 'none'; }}
                            />
                        </div>
                        <p className="text-sm text-slate-400 leading-relaxed font-medium max-w-sm">
                            {data.footer_desc || 'Arya Sabhyata Group is a leading provider of multi-disciplinary education, providing a pathway to global employability and thought leadership.'}
                        </p>
                    </div>

                    <div className="space-y-12">
                        <div>
                            <h4 className="text-white font-black uppercase tracking-widest text-sm mb-6 border-b-2 border-[#cc0000] inline-block pb-2">Reach Us</h4>
                            <div className="space-y-4 text-slate-400 font-bold uppercase tracking-wider text-[11px] mb-6">
                                <p className="flex items-start space-x-3 group cursor-default">
                                    <MapPin size={14} className="text-[#cc0000] flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="leading-tight group-hover:text-white transition-colors">{data.contact_address || "Anandanagar, Nischinda, Bally, Howrah, West Bengal 711227"}</span>
                                </p>
                                <p className="flex items-center space-x-3 group cursor-default">
                                    <Phone size={14} className="text-[#cc0000] flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="group-hover:text-white transition-colors">{data.contact_phone || '+91 000 000 0000'}</span>
                                </p>
                            </div>

                             <h4 className="text-white font-black uppercase tracking-widest text-sm mb-6 border-b-2 border-[#cc0000] inline-block pb-2">Connect With Us</h4>
                            <div className="flex space-x-4 mb-6">
                                {data.footer_facebook && (
                                    <a href={data.footer_facebook} target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-[#cc0000] hover:text-white transition-all shadow-lg shadow-black/20 group">
                                        <Facebook size={20} className="group-hover:scale-110 transition-transform" />
                                    </a>
                                )}
                                {data.footer_instagram && (
                                    <a href={data.footer_instagram} target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-[#cc0000] hover:text-white transition-all shadow-lg shadow-black/20 group">
                                        <Instagram size={20} className="group-hover:scale-110 transition-transform" />
                                    </a>
                                )}
                                {data.footer_linkedin && (
                                    <a href={data.footer_linkedin} target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-[#cc0000] hover:text-white transition-all shadow-lg shadow-black/20 group">
                                        <Linkedin size={20} className="group-hover:scale-110 transition-transform" />
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-white font-black uppercase tracking-widest text-sm mb-6 border-b-2 border-[#cc0000] inline-block pb-2">Find In Map</h4>
                        <div className="w-full h-48 rounded-sm overflow-hidden border border-white/5 opacity-80 hover:opacity-100 transition-opacity">
                            <iframe 
                                src={data.contact_map || "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.2624592415045!2d88.3224!3d22.644001000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f882cd1de08c8f:0xc39cbe2a80363b59!2sSurendralal%20Das%20Teachers'%20Training%20College!5e0!3m2!1sen!2sin!4v1774241287501!5m2!1sen!2sin"} 
                                width="100%" 
                                height="100%" 
                                style={{ border: 0 }} 
                                allowFullScreen="" 
                                loading="lazy" 
                                title="Campus Location"
                            ></iframe>
                        </div>
                    </div>
                </div>

                <div className="pt-6 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-[10px] font-black text-slate-500 uppercase tracking-[3px]">
                    <p>{data.footer_copyright || '© 2026 Arya Sabhyata Group of Institutions.'}</p>
                    <p className="mt-4 md:mt-0">{data.footer_managed_by || 'Managed by Palit Education Trust'}</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
